import { render, staticRenderFns } from "./ScreenAgrupados.vue?vue&type=template&id=3308d8da"
import script from "./ScreenAgrupados.vue?vue&type=script&lang=js"
export * from "./ScreenAgrupados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports